import styled from "@emotion/styled";
import {LAYOUT_CONSTANTS} from "../const";
import getThemeClasses from "../theme";

const {
  CONTENT_MAX_WIDTH,
  FEATURED_IMAGE_WIDTH,
  GUTTER_SIZE,
  FORM_ROW_PADDING,
} = LAYOUT_CONSTANTS;

const MainContainer = styled.main`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  box-sizing: border-box;
  
  width: 100%;
  margin: 0 auto;
  padding: 2px; // give focus outlines some breathing room
  
  background-color: ${({theme}) => theme.backgroundColor};
  font-family: ${({theme}) => theme.fontFamily};
  
  &.is-loading { min-height: 100vh; }
  
  ${({theme}) => getThemeClasses(theme)}

  // utility classes
  .form-row-padding {
    padding: ${FORM_ROW_PADDING};
  }

  .form-row-padding-x {
    padding: 0 ${FORM_ROW_PADDING};
  }
  
  .form-row-padding-y {
    padding: ${FORM_ROW_PADDING} 0;
  }
  
  .gutter {
    margin: ${GUTTER_SIZE}px;
  }
  
  .gutter-x {
    margin: 0 ${GUTTER_SIZE}px;
  }
  
  .gutter-y {
    margin: ${GUTTER_SIZE}px 0;
  }
  
  .gutter--1-2 {
    margin: calc(${GUTTER_SIZE}px / 2);
  }
  
  .gutter--1-2-x {
    margin: 0 calc(${GUTTER_SIZE}px / 2);
  }
  
  .gutter--1-2-y {
    margin: calc(${GUTTER_SIZE}px /2) 0;
  }

  ul {
    padding-left: ${FORM_ROW_PADDING};

    li::marker {
      color: ${({theme}) => theme.highlightColor};
    }
  }
  
  article {
    aside {
      margin: ${FORM_ROW_PADDING} 0;
      padding: ${FORM_ROW_PADDING};
      width: ${FEATURED_IMAGE_WIDTH}px;
      
      > section {
        padding: ${FORM_ROW_PADDING} 0;
        width: ${CONTENT_MAX_WIDTH}px;
      }   
    }
    
    blockquote {
      margin-top: calc(${FORM_ROW_PADDING} / 2);
      padding: ${FORM_ROW_PADDING} 0;
      
      > div {
        margin-right: ${FORM_ROW_PADDING};
      }
    }
  }
  
  @media ${({theme}) => theme.tablet} {
    article {
      aside {
        width: calc(100% + (${FORM_ROW_PADDING} * 4));
        
        > section {
          width: 100%;
          padding: 0 ${FORM_ROW_PADDING};
        }
      }
      
      blockquote {
        > div {
          position: relative;
          right: unset;
          margin-right: unset;
        }
      }
    }
  }
  
  
  @media ${({theme}) => theme.mobile} {
    overflow-x: hidden;

    article {
       aside {
        width: 100%;
        
        > section {
          width: 100%;
          padding: 0;
        }
      }
  
      blockquote {
        max-width: unset;
      }
    }
  }
`;

export default MainContainer;
